export class IndexExpense {
    i: number;
    u: number;
    g: number;
    constructor(i = null, u = null, g = null) {
        this.i = i;
       
        if (u !== null) {
            this.u = u;
        }
        if (g !== null) {
            this.g = g;
        }
       

    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/index-expense.ts